// extracted by mini-css-extract-plugin
export default {"userProfileOverlay":"UserProfile_userProfileOverlay__68our","userProfileContent":"UserProfile_userProfileContent__PZEy3","closeButton":"UserProfile_closeButton__OF3jA"};